import Mixin from "../../mixin.js";
import Label from "./Label.js";
import Funnel from "../../services/funnel-service.js";
import Utils from "../../services/utils-service.js";
import tooltip from "./tooltip.js"


const template = `
<fieldset :class="input.grid_class ? '' : 'grid'" :id="input.uid" v-show="fs.display(input)">


    <div v-if="input.type != 'hidden'" aria-live="polite" aria-atomic="true" class="sr-only" :id="input.uid+'_announcer'"></div>
    <legend v-if="input.force_label">
        <component v-if="input.force_label" :is="input.title_tag ? input.title_tag : 'h4'" :class="input.label_class" v-html="input.label"></component>
    </legend>

    <div :class="radio_count" v-if="input.checkbox_type == 1 || !input.checkbox_type">
        <ul :class="gridClass" role="group" :aria-labelledby="input.uid">
            <li class="s clm center checkbox-card checkbox_type_1" v-for="(item, index) in items" :key="index" :uid="input.uid" v-if="fs.display(item)">
                <b-tooltip :element='item' v-if="item.helpText"/>
                <input
                    :uid="input.uid+ '_option_' + index"
                    :type="input.type"
                    :id="input.id + '_option_' + index"
                    :name="item.name"
                    :checked="setChecked(item)"
                    @change="updateCheckbox($event, input);exec($event, input, {skipUpdate:true})"
                    :value="item.value"
                    :disabled="setDisabled(item.disabled)"
                    :data-uid="input.uid"
                    aria-labelledby="input.id + '_option_' + index + '_label'"
                />
                <qt-label :iuid="iuid" :img="fs.icon(item)" :key="fs.icon(item)" :item='item' :item_index='index' :id="input.id + '_option_' + index + '_label'"></qt-label>
            </li>
        </ul>
        <div class="error-here" role="alert" aria-live="assertive"></div>
        <input
            :uid="input.uid+ '_hidden_'"
            type="hidden"
            :id="input.id"
            :name="input.element_name"
            :value="input.value"
            v-bind="validationRules"
            :data-uid="input.uid+ '_hidden_'"
        />
    </div>

    <div class="s12 clm inline-checkbox-container" v-for="(item, index) in input.options" :uid="input.uid"  v-if="input.checkbox_type == 2 || input.checkbox_type == 'inline'">
         <input
            class="inline-checkbox"
            :uid="input.uid+ '_option_' + index"
            :type="input.type"
            :id="input.id + '_option_' + index"
            :name="item.name"
            :checked="setChecked(input)"
            @change="updateCheckbox($event, input);exec($event, input, {skipUpdate:true})"
            :value="item.value"
            :disabled="setDisabled(item.disabled)"
            :data-uid="input.uid"
        />
        <input
            :uid="input.uid+ '_hidden_'"
            type="hidden"
            :id="input.uid"
            :name="input.element_name"
            :value="input.value"
            v-bind="validationRules"
            :data-uid="input.uid+ '_hidden_'"
        />
       <qt-label :iuid="iuid" :img="fs.icon(item)" :key="fs.icon(item)" :item='item' :item_index='index'></qt-label>
       <div class="error-here"></div>
    </div>
    

</fieldset>
`;


export default {
    name: 'qt-input-checkbox',
    template,
    props: ['iuid'],
    mixins: [Mixin],
    components: {
        'qt-label': Label,
        'b-tooltip': tooltip
    },
    data() {
        return {
            optionNames: [],
            duplicateNames: []
        }
    },
    watch: {
        "input.loading": function (newVal, oldVal) {
           this.fs.elementAnnouncer(this.input)
        }, 
        // "input.options": {
        //     handler: function (newVal, oldVal) {
        //         console.log(newVal);
        //         this.announceCheckboxStatus();
        //     },
        //     deep: true
        // }
    },
    mounted: function () {
        this.disableCheckboxes(this);
        this.handleIIFE();
    },
    computed: {
        ...Vuex.mapGetters([
            'funnel',
            'custom_template_data'
        ]),
        input: function () {
            return this.$store.getters.funnel.elements[this.iuid];
        },
        validationRules() {
            return this.input.validation
        },
        items: function () {
            let items = [];
            const options = this.input.options
            var count = 0;

            if (options) {
                options.forEach(function (option, i) {
                    items.push(options[i])
                });
            }
            console.log('Items found', items);
            return items;
        },
        radio_count: function () {
            if (this.input.checkbox_class) {
                // if override exists then use that
                return this.input.checkbox_class
            }

            var count = 0;
            var options = this.input.options
            if (options) {
                options.forEach(function (option) {
                    count++;
                });
            }

            if (count === 2) {
                var offset = 's12 m8 l6 center'
            } else if (count === 3) {
                var offset = 's12 m8 l6 center'
            } else if (count === 4) {
                var offset = 's12 m8 center'
            } else if (count === 5) {
                var offset = 's12 m10 center'
            }
            return offset;
        },
        fs: function () {
            return new Funnel({ ctx: this.$store, router: this.$router });
        },
        gridClass: function () {
            var self = this
            var total_items = this.input.options.filter(function (item) {
                return self.fs.display(item)
            })


            if (this.input.grid_class) {
                var grid_size = this.input.grid_class
                var grid = "block-grid-s1 block-grid-m" + grid_size
            } else {
                var grid_size = total_items.length
                var grid = "block-grid-s1 block-grid-m" + (grid_size - 1) + " block-grid-l" + grid_size
            }
            return grid
        }
    },
    methods: {
        disableCheckboxes: function (self) {
            if (!Utils.isEmpty(self.input.limit)) {
                const disable = self.input.value.length >= self.input.limit

                for (var i = 0; i < self.input.options.length; i++) {
                    // const elements = document.getElementsByName(opt.name);
                    const opt = self.input.options[i]
                    const valueNotChecked = self.input.value.indexOf(opt.value) == -1
                    console.log(disable && valueNotChecked);
                    if (disable && valueNotChecked) {
                        self.$store.commit('UPDATE_FUNNEL_ELEM_OPTION', { iuid: self.input.uid, index: i, key: 'disabled', val: true });
                    } else {
                        self.$store.commit('UPDATE_FUNNEL_ELEM_OPTION', { iuid: self.input.uid, index: i, key: 'disabled', val: false });
                    }

                }
            }
        },
        setChecked(item) {
            if (typeof this.input.value === "object") {
                const itemArray = new Set(this.input.value)
                let is_checked = itemArray.has(item.value)

                if (!is_checked) {
                    $('#'+this.input.uid+'_announcer').text(item.label + " deselected.")
                }
                return itemArray.has(item.value)
            }
            else
                return this.input.value.indexOf(item.value) > -1
        },
        setDisabled(disabled) {
            return Utils.isTruthy(disabled);
        },
        updateCheckbox(e) {
            console.log('updatecheckbox ran');
            const uuid = this.input.uid
            const target = e.target

            const optionNames = new Set();
            const duplicateNames = new Set();

            for (const obj of this.input.options) {
                if (optionNames.has(obj.name))
                    duplicateNames.add(obj.name);
                else
                    optionNames.add(obj.name);
            }

            if (duplicateNames.has(target.name)) {
                const duplicateElements = document.getElementsByName(target.name);
                for (const elem of duplicateElements) {
                    if (elem.value != target.value) {
                        elem.checked = false;
                        this.$store.commit('UPDATE_CHECKBOX_DATA', { uuid, actionType: 'remove', value: elem.value });
                    }
                }
            }
            console.log(optionNames, duplicateNames);
            this.$store.dispatch('updateCheckboxData', { uuid, target })

            // Disable checkboxes if limit is met
            this.disableCheckboxes(this)
        },
        // announceCheckboxStatus: function(e){

        //     // console.log(e.target, );
        //     // let item_label = $("label[for="+e.target.id+"]").text().replace(/\n/g, "");
        //     // let is_checked = e.target.checked;
        //     for (const item of this.input.options) {
        //         if (item.disabled) {
        //             $('#'+this.input.uid+'_announcer').text(item.label + " checkbox disabled. Selecting this item is not possible with your current selection.")
        //         }
        //     }
        // }
    }
};
